import { StaffType } from './staff.model';

export type StaffAltaWizardStep = 1 | 2 | 3;

export const STAFF_ALTA_WIZARD_STEP_LABELS: readonly string[] = [
  'Descargar plantilla',
  'Validación de formato',
  'Resultado final',
];

export const STAFF_ALTA_TYPE_LABELS: Record<StaffType, string> = {
  LE: 'Staff LE',
  GES: 'Staff GES',
};

export const XLSX_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export type StaffAltaFormatoEstado = 'CUMPLE_FORMATO' | 'NO_CUMPLE_FORMATO';

export interface StaffAltaValidationRow {
  readonly fila: number;
  readonly rutProfesional: string;
  readonly nombre: string;
  readonly estado: StaffAltaFormatoEstado;
  readonly motivos: readonly string[];
}

export interface StaffAltaValidationResult {
  readonly estructuraValida: boolean;
  readonly totalRecibidos: number;
  readonly totalOk: number;
  readonly totalConErrores: number;
  readonly filas: readonly StaffAltaValidationRow[];
}

export type StaffAltaProcessStatus = 'APROBADO' | 'RECHAZADO' | 'EN_REVISION';

export const STAFF_ALTA_PROCESS_STATUS_LABELS: Record<StaffAltaProcessStatus, string> = {
  APROBADO: 'Aprobado',
  RECHAZADO: 'Rechazado',
  EN_REVISION: 'Provisorio',
};

export interface StaffAltaProcessRow {
  readonly fila: number;
  readonly rutProfesional: string;
  readonly nombre: string;
  readonly estado: StaffAltaProcessStatus;
  readonly detalle: string;
}

export interface StaffAltaProcessResult {
  readonly totalProcesados: number;
  readonly aprobados: number;
  readonly rechazados: number;
  readonly enRevision: number;
  readonly omitidosPorFormato: number;
  readonly filas: readonly StaffAltaProcessRow[];
}
